module.exports = __webpack_public_path__ + "img/outlander.8b6b4e8f.png";